export const onboardingKeys = {
  // Prefix key — use for invalidation to match all progress queries regardless of org/project
  all: () => ["onboarding", "progress"] as const,
  progress: (orgId?: string, projectId?: string) =>
    ["onboarding", "progress", orgId, projectId] as const,
};
